import Footer from "./Footer.component";

export default Footer;
